<template>
  <SearchInput
    placeholder="Search for shipments by tracking reference"
    :value="searchTerm"
    @changeValue="setSearchTerm"
    @clear="onClearSearch"
  />
</template>
<script>
import SearchInput from '../../atoms/input/search-input';
import { routeNames } from '../../../constants';

export default {
  name: 'ShipmentsSearch',
  components: {
    SearchInput,
  },
  data() {
    return {
      timeoutId: null,
    };
  },
  computed: {
    searchTerm() {
      return this.$store.state.shipments.searchTerm;
    },
    isShipmentDetailOpen() {
      return this.$route.name === routeNames.shipments.detail;
    },
  },
  watch: {
    searchTerm() {
      this.searchShipmentsDebounced();
    },
  },
  created() {
    this.$store.commit('shipments/RESET_SEARCH_TERM');
  },
  methods: {
    setSearchTerm(value) {
      this.$store.commit('shipments/SET_SEARCH_TERM', value);

      if (value) {
        this.closeShipmentDetail();
      }
    },
    searchShipmentsDebounced() {
      // cancel pending call
      clearTimeout(this.timeoutId);

      // delay new call 500ms
      this.timeoutId = setTimeout(() => {
        this.$store.dispatch('shipments/refreshGetShipments').then(() => {
          this.$root.trackEvent.searchedShipments(
            this.searchTerm,
            this.$store.state.shipments.shipments.length,
          );
        });
      }, this.$store.getters['shipments/isSearching'] ? 300 : 0); // makes clear search instant
    },
    onClearSearch() {
      this.$root.trackEvent.clearedShipmentsSearch(
        this.value,
        this.$store.state.shipments.shipments.length,
      );
      this.closeShipmentDetail();
    },
    closeShipmentDetail() {
      if (this.isShipmentDetailOpen) {
        this.$router.push({
          name: routeNames.shipments.list,
          query: this.$route.query,
        }).catch(() => {
        // duplicate navigation - already on shipments list
        });
      }
    },
  },
};
</script>
